var ratio = 1;
var formSubmitted = false;
var windowWidth = window.innerWidth;

import './bootstrap';
import { playRandomSequentialVideos, initializeOfflineVideos } from './videos';
import { setScreenSaver, stopScreenSaver } from './screensaver';
import localStorage from './localstorage';
import calcData from './updatedData.json';
// import animateCss from './animate';
// import landscapeModal from './landscape';
import Big from 'big.js/big.mjs';
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import {loadAnimations, clearAnimations} from './lottie';
import UIkit from 'uikit';
gsap.registerPlugin(ScrollToPlugin, Draggable);
import { resetAllForms } from './utils';
import { initializeOfflineImages } from './offlineImages';
import { languageManager } from './translations';

const debugstate = false;

export const handleDecline = () => {
    alert("You must accept the terms to be able to use this tool.");
};

document.addEventListener('DOMContentLoaded', function () {
    window.debug = function (msg) { debugstate ? console.log(msg) : null; }

    const termsModal = UIkit.modal('#modal-currency-onLoad', { escClose: false, bgClose: false });
    const termsModalNextPage = UIkit.modal('#modal-terms-nextPage', { escClose: false, bgClose: false });
    const termsModalNextPageUS = UIkit.modal('#modal-terms-nextPage-US', { escClose: false, bgClose: false });
    const chooseCurrency = document.querySelector('#modal-currency-onLoad .uk-button-orange');
    const acceptButtonNextPage = document.querySelector('#modal-terms-nextPage .uk-button-orange');
    const declineButtonNextPage = document.querySelector('#modal-terms-nextPage .uk-button-perkins');
    const acceptButtonNextPageUS = document.querySelector('#modal-terms-nextPage-US .uk-button-orange');
    const declineButtonNextPageUS = document.querySelector('#modal-terms-nextPage-US .uk-button-perkins');

    const lockPage = () => {
        termsModal.show();
        document.body.style.overflow = 'hidden';
    };

    const unlockPageChooseCurrency = (currency) => {    
        termsModal.hide();
        if (currency === 'USD') {
            termsModalNextPageUS.show();
        } else {
            termsModalNextPage.show();
        }
    };

    const unlockPage = () => {
        document.body.style.overflow = ''; // Restore scrolling
        termsModalNextPage.hide();
        termsModalNextPageUS.hide(); // Close the modals
    };

    setupLanguageSwitcher();

    // Add a small delay to ensure the DOM is fully loaded and UIkit is initialized
    setTimeout(() => {
        lockPage();

        var currencySelect = document.querySelector('#currency');
        var selectedCurrency = currencySelect?.value || 'GBP';
            
        currencySelect.addEventListener('change', function() {
            selectedCurrency = this.value;
        });
        
        if (chooseCurrency) {
            chooseCurrency.addEventListener('click', function() {
                selectedCurrency = currencySelect?.value || 'GBP';
                const currentLanguage = languageManager.getCurrentLanguage();
                const isUsLanguage = currentLanguage === 'en-us';
                const gbpToUsdRate = getCookieOrDefault('us_exchange', 1);
                const gbpToEurRate = getCookieOrDefault('eu_exchange', 1);
                const gbpToCnyRate = getCookieOrDefault('cy_exchange', 1);
                const fuelCostPerLitreUs = getCookieOrDefault('us_fuel_cost', Big(getCookieOrDefault('fuel_cost', 1.56)).times(gbpToUsdRate).toNumber());
                const labourCostPerHourUs = getCookieOrDefault('us_labour_cost', Big(getCookieOrDefault('labour_cost', 60)).times(gbpToUsdRate).toNumber());
                const fuelCostPerLitreEu = getCookieOrDefault('eu_fuel_cost', Big(getCookieOrDefault('fuel_cost', 1.56)).times(gbpToEurRate).toNumber());
                const labourCostPerHourEu = getCookieOrDefault('eu_labour_cost', Big(getCookieOrDefault('labour_cost', 60)).times(gbpToEurRate).toNumber());

                if (isUsLanguage) {
                    document.querySelector('#modal-terms-nextPage-US .cost').textContent = labourCostPerHourUs;
                    document.querySelector('#modal-terms-nextPage-US .fuelcost').textContent = fuelCostPerLitreUs;
                } else {
                    let currencySign = '£';
                    let labourCost = getCookieOrDefault('labour_cost', 60);
                    let fuelCost = getCookieOrDefault('fuel_cost', 1.56);
                    
                    if (selectedCurrency === 'USD') {
                        currencySign = '$';
                        labourCost = labourCostPerHourUs;
                        fuelCost = fuelCostPerLitreUs;
                    } else if (selectedCurrency === 'EUR') {
                        currencySign = '€';
                        labourCost = labourCostPerHourEu;
                        fuelCost = fuelCostPerLitreEu;
                    } else if (selectedCurrency === 'CNY') {
                        currencySign = '¥';
                        // Add CNY costs if available
                    }
                    
                    document.querySelectorAll('#modal-terms-nextPage .currency-sign').forEach(el => {
                        el.textContent = currencySign;
                    });
                    document.querySelector('#modal-terms-nextPage .cost').textContent = labourCost;
                    document.querySelector('#modal-terms-nextPage .fuelcost').textContent = fuelCost;
                }

                unlockPageChooseCurrency(selectedCurrency);
            });
        }

        // Set up other button click handlers
        acceptButtonNextPage?.addEventListener('click', unlockPage);
        acceptButtonNextPageUS?.addEventListener('click', unlockPage);
        declineButtonNextPage?.addEventListener('click', handleDecline);
        declineButtonNextPageUS?.addEventListener('click', handleDecline);

        initializeOfflineImages();
        initializeOfflineVideos();

    }, 500);

    localStorage();

    // window.addEventListener('resize', landscapeModal);
    // landscapeModal();
    setScreenSaver();

    const events = ["keypress", "click", "touchstart"];
    const screensaverEl = document.getElementById("screensaver");
    if (screensaverEl) {
        events.forEach(event => screensaverEl.addEventListener(event, stopScreenSaver));
    }
    
    var output = document.getElementById("output");
    var hoursInput = document.getElementById("hours");
    
    // Select elements you want to prevent drag
    var panelElements = document.querySelectorAll('.panel-container');
        
    function preventDrag(event) {
        event.preventDefault();
    }

    panelElements.forEach(function(element) {
        element.addEventListener('touchmove', preventDrag, { passive: false });
    });

    function updateValues(rotation) {
        var value = (rotation / 240) * (8500 - 500) + 500;
        value = Math.round(value); 
        
        output.innerHTML = value;
        hoursInput.value = value;
    }

    function initializeDraggable() {
        var knob = document.getElementById("dialInner"); // Ensure this element exists in your HTML
    
        // Setup Draggable
        Draggable.create(knob, {
            type: "rotation",
            inertia: true,
            minRotation: 0,
            maxRotation: 240,
            onDrag: function() {
                updateValues(this.rotation);
            },
            onThrowUpdate: function() {
                updateValues(this.rotation);
            },
            liveSnap: function(rotation) {
                var valuePerDegree = (8500 - 500) / 240;
                var incrementValue = 100; // Value increment
                var degreesPerIncrement = incrementValue / valuePerDegree;
                var snapRotation = Math.round(rotation / degreesPerIncrement) * degreesPerIncrement;
                return Math.min(Math.max(snapRotation, 0), 240);
            }
        });
    
        resetDialToDefault(); // Call this here if you want to reset to default on each initialization
    }
    
    function resetDialToDefault() {
        var knob = document.getElementById("dialInner");
        var output = document.getElementById("output");
        var hoursInput = document.getElementById("hours");
        
        var value = 500;
        var rotationEquivalent = 0;
        if (knob) {
            knob.style.transform = 'rotate(' + rotationEquivalent + 'deg)';
        }
    
        gsap.to("#dialInner", {
            duration: 0.5,
            rotation: rotationEquivalent,
            onComplete: function() {
                if (output && hoursInput) {
                    output.innerHTML = value;
                    hoursInput.value = value;
                }
            }
        });
    }

    // Function to get cookie value by name
    window.getCookie = function(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }

    // scale page 
    function scalePage(target) {
        var baseWidthForScale = 3840;
        var targetScale = 2.5;
        var dynamicScale = (windowWidth / baseWidthForScale) * targetScale;
        var adjustedBaseWidth = window.innerWidth / dynamicScale;

        var elements = document.querySelectorAll('.scaler--40');
        elements.forEach(function(element) {
            var style = window.getComputedStyle(element);
            var paddingLeft = parseFloat(style.paddingLeft);
            var paddingRight = parseFloat(style.paddingRight);
            var totalWidth = adjustedBaseWidth - paddingLeft - paddingRight;
            element.style.width = totalWidth + 'px';
        });

        adjustScale();
        initializeDraggable();
    }

    function adjustScale() {
        var baseWidth = 3840;
        var targetScale = 2.5;
    
        var viewportWidth = window.innerWidth;
        var newScale = (viewportWidth / baseWidth) * targetScale;
    
        var elements = document.querySelectorAll('.scaler');
        elements.forEach(function(element) {
            element.style.transform = 'scale(' + newScale + ')';
        });
    }

    window.addEventListener('resize', function() { scalePage('.aspect-ratio-wrapper'); });
    window.onload = function() { scalePage('.aspect-ratio-wrapper'); };

    const result = document.getElementById('result');

    if (document.querySelectorAll('#fullpage').length) { // don't setup fullpage on the back-end pages
        // set up fullpage
        new fullpage('#fullpage', {
            licenseKey: 'QMB57-6NJVJ-8JNWI-7D4QK-KBEWM', // NEED LICENSE KEY HERE
            autoScrolling: true,
            scrollOverflow: true,
            dragAndMove: false,
            autoScrolling: false,
            touchSensitivity: 0,
            normalScrollElements: '.panel-container',
            anchors: ['m1','m2','m3','m4'],
            afterLoad: function(origin, destination, direction){
                var loadedSection = this;
                if(destination.item.querySelector('.border-element__thin--inner')){
                  destination.item.querySelector('.border-element__thin--inner').classList.add('animate-width');
                }
            },
            onLeave: function(origin, destination, direction) {
                if(origin.item.querySelector('.border-element__thin--inner')){
                    origin.item.querySelector('.border-element__thin--inner').classList.remove('animate-width');
                    origin.item.querySelector('.border-element__thin--inner').style.width = '0%';
                }
                if(origin.index === 0 && destination.index === 1){
                    playRandomSequentialVideos();
                }
            }
        });

        var resetButton = document.getElementById('reset');
        var homeButtons = document.getElementsByClassName('home');
        Array.from(homeButtons).forEach(function(homeButton) {
            homeButton.addEventListener('click', function(event) {
                event.preventDefault(); 
                clearAnimations();
                resetAllForms(); 
                resetDialToDefault();
                lockPage();
                fullpage_api.moveTo('m1', 1);
            });
        });
        if (resetButton) {
            resetButton.addEventListener('click', function(event) {
                event.preventDefault(); 
                clearAnimations();
                resetAllForms(); 
                resetDialToDefault();
                lockPage();
                fullpage_api.moveTo('m1', 1);
            });
        }
        
        // Add click event listeners to buttons
        document.querySelectorAll('.js-next').forEach(nextButton => {
            nextButton.addEventListener('click', (event) => {
                event.preventDefault();
                let currentIndex = parseInt(nextButton.dataset.current);
                const currentSection = document.querySelector('#fullpage > :nth-child(' + currentIndex + ')');
                const nextIndex = currentIndex + 1;
                const nextSection = document.querySelector('#fullpage > :nth-child(' + nextIndex + ')');

                var engineOperationHoursPA = document.querySelector("#hours").value;
                var modelType = document.querySelector("#model-type").value;

                if(modelType && engineOperationHoursPA) {
                    if(currentSection.classList.contains('js-calculation-form')) {
                        fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                        currentIndex = currentIndex + 1;
                        calculateResults(engineOperationHoursPA, modelType);
                        setTimeout(function() {
                            fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                            loadAnimations();
                        }, 10 * 1000); 
                    } else if(currentSection.classList.contains('js-form-section')) {
                        // This will be for the data capture part
                        if (!event.target.classList.contains('skip')) {
                            const name = document.getElementById('signup-first-name').value;
                            const surname = document.getElementById('signup-surname').value;
                            const email = document.getElementById('signup-email').value;
                            const country = document.getElementById('signup-country').value;
                            var marketingCheckbox = document.querySelector('#marketing-wrapper input[type="checkbox"][name="marketing"]');
                            const marketing = marketingCheckbox.checked ? "1" : "0";
                            const csrf = document.querySelector('meta[name="csrf-token"]').content;

                            if (name == '' || surname == '' || email == '' || country == '' || marketing != 1) {
                                showError('Please complete the form');
                                return;
                            } else {
                                var savedMode = window.getCookie('app_mode') || navigator.onLine;

                                if (savedMode === 'online' || savedMode) {
                                    const csrf = document.querySelector('meta[name="csrf-token"]').content;

                                    var formData = new FormData();
                                    formData.append('name', name);
                                    formData.append('surname', surname);
                                    formData.append('email', email);
                                    formData.append('country', country);
                                    formData.append('marketing', marketing);
                                    formData.append('when', Date());
                                    formData.append('csrf_token', csrf);

                                    // Add a timeout to prevent hanging
                                    const controller = new AbortController();
                                    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
                                    
                                    // Send form data using POST
                                    fetch('/form/', {
                                        method: 'POST',
                                        body: formData,
                                        signal: controller.signal
                                    }).then(function(response) {
                                        clearTimeout(timeoutId);
                                        if (response.ok) {
                                            console.log('Form submitted successfully to server');
                                            alert('Thank you for enquiring, please hit home if you wish to reuse the tool!');
                                            return response.text(); 
                                        } else {
                                            console.error('Server returned error:', response.status);
                                            alert('Form stored locally. We\'ll try to submit it again when you\'re online.');
                                        }
                                    }).then(function(responseText) {
                                        if (responseText) console.log('Server response:', responseText);
                                    }).catch(function(error) {
                                        
                                        window.storeDataLocally({
                                            name: name,
                                            surname: surname,
                                            email: email,
                                            country: country,
                                            marketing: marketing,
                                            when: Date(),
                                            csrf_token: csrf
                                        });

                                        clearTimeout(timeoutId);
                                        if (error.name === 'AbortError') {
                                            console.error('Request timed out');
                                            alert('Request timed out. Your form has been saved locally.');
                                        } else {
                                            console.error('Fetch error:', error);
                                            alert('Network error. Your form has been saved locally.');
                                        }
                                    }).finally(function() {
                                        resetAllForms();
                                    });
                                } else {
                                    window.storeDataLocally({
                                        name: name,
                                        surname: surname,
                                        email: email,
                                        country: country,
                                        marketing: marketing,
                                        when: Date(),
                                        csrf_token: csrf
                                    }).then(function(){
                                        alert('Thank you for enquiring!');
                                        resetAllForms(); 
                                    });
                                }
                            }
                        }
                    } else {
                        fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                    }
                } else {
                    alert('Please fill in all required fields.');
                }
            });
        });
    }

    if (document.querySelectorAll('#data-counter').length) {
        window.getCount();
    }

    function showError(message) {
        UIkit.notification({
            message: message,
            status: 'danger',
        });
    }

    function formatCurrency(value, currencySymbol = '£', decimals = 2) {
        let num = Big(value).toFixed(decimals);
        const isNegative = num < 0;
        num = num.replace('-', '');
        let numParts = num.split('.');
        numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        if (decimals > 0) {
            num = numParts.join('.');
        } else {
            num = numParts[0]; // Use the integer part only
        }   
        return `${isNegative ? '' : ''}${currencySymbol}${num}`;
    }    

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }

    function getCookieOrDefault(cookieName, defaultValue) {
        var value = getCookie(cookieName);
        return value ? value : defaultValue;
    }

    const data = calcData;
    function calculateResults(engineOperationHoursPA, modelType) {
        var serviceInterval = 500;
        var operatingTimeYears, discountFiltersOnWillFit; 

        var discountFiltersOnWillFit = getCookieOrDefault('discount_amount', 50) / 100;
        var operatingTimeYears = getCookieOrDefault('operating_cost', 3);
        const currentLanguage = languageManager.getCurrentLanguage();
        const isUsLanguage = currentLanguage === 'en-us';
        const baseCurrency = isUsLanguage ? 'USD' : 'GBP';
        const gbpToUsdRate = getCookieOrDefault('us_exchange', 1);
        const gbpToEurRate = getCookieOrDefault('eu_exchange', 1);
        const gbpToCnyRate = getCookieOrDefault('cy_exchange', 1);
        const baseFuelCostPerLitre = isUsLanguage
            ? (getCookieOrDefault('us_fuel_cost', Big(getCookieOrDefault('fuel_cost', 1.56)).times(gbpToUsdRate).toNumber()))
            : getCookieOrDefault('fuel_cost', 1.56);
        const baseLabourCostPerHour = isUsLanguage
            ? (getCookieOrDefault('us_labour_cost', Big(getCookieOrDefault('labour_cost', 60)).times(gbpToUsdRate).toNumber()))
            : getCookieOrDefault('labour_cost', 60);
        const engineCostsToBaseRate = baseCurrency === 'USD' ? gbpToUsdRate : 1;
        let displayExchangeRate = 1;
        let currencySign = "£";
        var selectedCurrency = document.getElementById('currency').value;

        const modelData = data.engineModels.find(model => model.model === modelType);
        if (!modelData) {
            console.error("Model not found");
            return;
        }
        
        // Determine final display exchange rate based on selected currency (convert from base currency -> selected currency)
        if (selectedCurrency === 'USD') {
            currencySign = "$";
            displayExchangeRate = baseCurrency === 'USD' ? 1 : gbpToUsdRate;
        } else if (selectedCurrency === 'EUR') {
            currencySign = "€";
            displayExchangeRate = baseCurrency === 'USD' ? (gbpToUsdRate ? (gbpToEurRate / gbpToUsdRate) : 1) : gbpToEurRate;
        } else if (selectedCurrency === 'CNY') {
            currencySign = "¥";
            displayExchangeRate = baseCurrency === 'USD' ? (gbpToUsdRate ? (gbpToCnyRate / gbpToUsdRate) : 1) : gbpToCnyRate;
        } else {
            currencySign = "£";
            displayExchangeRate = baseCurrency === 'USD' ? (gbpToUsdRate ? (1 / gbpToUsdRate) : 1) : 1;
        }
        
        // Saving by Buying non-genuine
        var filterDNETBase = Big(modelData.filterDNET).times(engineCostsToBaseRate);
        var filterDNET35 = Big(filterDNETBase).times(0.35).plus(Big(filterDNETBase));
        var filterDNET50 = Big(filterDNET35).times(0.5).plus(filterDNET35);
        var costForGenuineFilter = filterDNET50;
        var servicesInPeriod = Big(engineOperationHoursPA).div(serviceInterval).times(Big(operatingTimeYears));    
        var filterCostGenuine = Big(costForGenuineFilter).times(Big(servicesInPeriod));
        var filterCostForWillFit = Big(1 - discountFiltersOnWillFit).times(costForGenuineFilter).times(servicesInPeriod);
        var savingNonGenuine = Big(filterCostForWillFit).minus(filterCostGenuine);

        // Increased Fuel Costs
        var operatingHours = Big(engineOperationHoursPA).times(operatingTimeYears);
        var fuelConsumptionLitres = modelData.fuelConsumptionPerHours;
        var LitresConsumded = Big(operatingHours).times(Big(fuelConsumptionLitres));
        var fuelCost = Big(LitresConsumded).times(Big(baseFuelCostPerLitre));
        var increasedFuelCost = Big(fuelCost).times(Big(modelData.fuelUseIncrease));

        var injectorReplacementTime = Big(100).minus(Big(100).times(Big(modelData.increaseInReplacements))).times(Big(modelData.injectorReplacementHours)).div(100);
        
        // Calculation for injector replacement (will fit)
        var numberOfInjectorsReplacementsNonGen = Big(operatingHours).lt(injectorReplacementTime) ? 0 : Big(operatingHours).div(injectorReplacementTime);

        // Calculation for injector replacement (Genuine)
        var numberOfInjectorsReplacementsGen = Big(operatingHours).gt(Big(modelData.injectorReplacementHours)) ? Big(operatingHours).div(Big(modelData.injectorReplacementHours)) : 0;

        // Cost of injector and replacement using will-fit filters (K8)
        var injectorCostBase = Big(modelData.injectorCosts).times(engineCostsToBaseRate);
        var costOfReplacementInjectors = Big(modelData.noOfInjectors).times(injectorCostBase); // modelData.injectorCosts needs to be float to two decimal places
        var costOfLabour = Big(baseLabourCostPerHour).times(Big(modelData.hoursToChangeInjectors));
        var totalInjectorReplacementCost = Big(costOfLabour).plus(costOfReplacementInjectors);

        // Since we're rounding to the nearest whole number for replacements, apply appropriate rounding
        var numberOfInjectorsReplacementsNonGenRounded = Big(numberOfInjectorsReplacementsNonGen).round(0, Big.roundDown);
        var numberOfInjectorsReplacementsGenRounded = Big(numberOfInjectorsReplacementsGen).round(0, Big.roundDown);

        var costOfInjectorAndWillfitFilters = Big(numberOfInjectorsReplacementsNonGenRounded).times(totalInjectorReplacementCost);
        var costOfInjectorAndReplacementGenuineFilters = Big(numberOfInjectorsReplacementsGenRounded).times(totalInjectorReplacementCost);
        var additionalReplacementCost = Big(costOfInjectorAndWillfitFilters).minus(costOfInjectorAndReplacementGenuineFilters);
        var impactAdditionalCost2Customer = Big(savingNonGenuine).plus(increasedFuelCost).plus(additionalReplacementCost);

        // Update this based on currency choice to change the ID to icon_1_dollar or icon_1_euro when currency is chosen.
        // First, reset any existing currency-specific IDs back to original
        const icon1Element = document.querySelector('[id^="icon_1_"]') || document.querySelector('#icon_1');
        const icon4Element = document.querySelector('[id^="icon_4_"]') || document.querySelector('#icon_4');
        
        if (icon1Element && icon4Element) {
            // Reset to original IDs first
            icon1Element.id = 'icon_1';
            icon4Element.id = 'icon_4';
            
            // Then apply currency-specific IDs
            if (currencySign === '$') {
                icon1Element.id = 'icon_1_dollar';
                icon4Element.id = 'icon_4_dollar';
            } else if (currencySign === '€') {
                icon1Element.id = 'icon_1_euro';
                icon4Element.id = 'icon_4_euro';
            } else if (currencySign === '¥') {
                icon1Element.id = 'icon_1_yen';
                icon4Element.id = 'icon_4_yen';
            }
        }
        const assumptionsCurrencySign = currencySign;
        const assumptionsLabourCost = baseLabourCostPerHour;
        const assumptionsFuelCost = baseFuelCostPerLitre;
        document.querySelectorAll('#modal-terms .currency-sign').forEach(el => {
            el.textContent = assumptionsCurrencySign;
        });
        document.querySelector('#modal-terms .cost').textContent = assumptionsLabourCost;
        document.querySelector('#modal-terms .fuelcost').textContent = assumptionsFuelCost;

        document.querySelector('#saving-figure .countup').innerHTML = formatCurrency(convertCurrency(savingNonGenuine, displayExchangeRate), currencySign, 0);
        document.querySelector('#fuelcost-figure .countup').innerHTML = formatCurrency(convertCurrency(increasedFuelCost, displayExchangeRate), currencySign, 0);
        document.querySelector('#replacement-figure .countup').innerHTML = formatCurrency(convertCurrency(additionalReplacementCost, displayExchangeRate), currencySign, 0);
        document.querySelector('#impact-figure .countup').innerHTML = formatCurrency(convertCurrency(impactAdditionalCost2Customer, displayExchangeRate), currencySign, 0);
        
        // Update translations after calculation results are displayed
        languageManager.updatePageTranslations();
    }

    function convertCurrency(value, exchangeRate) {
        try {
            // Handle null, undefined or invalid inputs
            if (value === null || value === undefined || exchangeRate === null || exchangeRate === undefined) {
                console.warn('convertCurrency received invalid input:', { value, exchangeRate });
                return Big(0);
            }
            
            // If value is already a Big instance, use it directly
            const bigValue = value instanceof Big ? value : Big(value);
            
            return bigValue.times(exchangeRate);
        } catch (error) {
            console.error('Error in convertCurrency:', error, { value, exchangeRate });
            return Big(0);
        }
    }
});

function preventDrag(event) {
    event.preventDefault();
}


// Language switcher setup
function setupLanguageSwitcher() {
    const languageContainer = document.getElementById('language-switcher');
    const languageButtons = document.querySelectorAll('.language-btn');

    // Set active language button on load
    const currentLang = languageManager.getCurrentLanguage();
    languageButtons.forEach(btn => {
        if (btn.dataset.lang === currentLang) {
            btn.classList.add('uk-button-primary');
            btn.classList.remove('uk-button-default');
        } else {
            btn.classList.add('uk-button-default');
            btn.classList.remove('uk-button-primary');
        }
    });

    if (!languageContainer) {
        console.warning("Element with ID 'language-switcher' not found.")
        return;
    }

    // Delegate clicks so dynamically injected buttons still work
    languageContainer.addEventListener('click', (event) => {
        const button = event.target.closest('.language-btn');
        if (!button) {
            return;
        }

        const selectedLang = button.dataset.lang;
        if (!selectedLang) {
            return;
        }

        if (languageManager.setLanguage(selectedLang)) {
            languageButtons.forEach(btn => {
                if (btn.dataset.lang === selectedLang) {
                    btn.classList.add('uk-button-primary');
                    btn.classList.remove('uk-button-default');
                } else {
                    btn.classList.add('uk-button-default');
                    btn.classList.remove('uk-button-primary');
                }
            });

            // Update all translations on the page
            languageManager.updatePageTranslations();

            // Update alert messages for current context
            updateAlertMessages();
        }
    });
}

// Update alert messages when language changes
function updateAlertMessages() {
    // This function ensures alert messages use the current language
    // The actual alerts will use languageManager.translate() when called
}

// Listen for language changes to update dynamic content
document.addEventListener('languageChanged', function(event) {
    updateMobilePickerText();
});

// Update mobile picker text when language changes
function updateMobilePickerText() {
    const modelTypeMobile = document.getElementById('model-type-mobile');
    if (modelTypeMobile) {
        modelTypeMobile.textContent = languageManager.translate('choose-engine-model');
    }
}